import React from 'react';
import { Field } from 'formik';
import ComponentStyle from './ComponentStyle';
import { FormContextConsumer } from './FormContext';

const ValidationField = React.forwardRef((props, ref) => {
    const { formContext, className, ...rest } = props;

    let { disabled, readOnly } = formContext ? formContext : {};
    disabled = typeof props.disabled === 'undefined' ? disabled : props.disabled;
    readOnly = typeof props.readOnly === 'undefined' ? readOnly : props.readOnly;

    const onKeyPress = (e) => {
        if (props.restrict) {
            if (!props.restrict.test(e.key)) e.preventDefault();
        }
        if (props.onKeyPress && typeof props.onKeyPress === 'function') {
            props.onKeyPress(e);
        }
    };

    return (
        <ComponentStyle
            name={props.name}
            className={className}
            render={(classes) => (
                <Field {...rest}>
                    {({ field }) => {
                        return (
                            <div>
                                <input
                                    type="text"
                                    {...field}
                                    {...rest}
                                    className={disabled ? className : classes}
                                    ref={ref}
                                    onKeyPress={onKeyPress}
                                    disabled={disabled}
                                    readOnly={readOnly}
                                    onBlur={(event) => {
                                        field.onBlur(event);
                                        if (typeof props.onBlur === 'function') props.onBlur(event);
                                    }}
                                    onChange={(event) => {
                                        field.onChange(event);
                                        if (typeof props.onChange === 'function') props.onChange(event);
                                    }}
                                />
                            </div>
                        );
                    }}
                </Field>
            )}
        />
    );
});

ValidationField.displayName = 'ValidationField';

const WrappedValidationField =  React.forwardRef((props, ref) => {
    return (
        <FormContextConsumer>
            {(context) => {
                return <ValidationField {...props} formContext={context} ref={ref} />;
            }}
        </FormContextConsumer>
    );
});

WrappedValidationField.displayName = 'WrappedValidationField';
export default WrappedValidationField;
